import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VExpansionPanel,[_c(VExpansionPanelHeader,{staticClass:"pl-2"},[_c(VIcon,{staticClass:"flex-grow-0 pr-4"},[_vm._v(" explore ")]),_c('span',[_vm._v("Background Overview")])],1),_c(VExpansionPanelContent,_vm._l((_vm.summaryItems),function(item,index){return _c(VRow,{key:index,staticClass:"text-caption"},[_c(VCol,[_vm._v(_vm._s(item.text))]),_c(VCol,[_vm._v(_vm._s(item.value))])],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }